
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/work/canvas-deploy/generated/ui/shared/tree-browser-view/jst/TreeCollection';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, self=this;

function program1(depth0,data) {
  
  
  return "\n<ul class=\"collectionViewItems\"></ul>\n";
  }

  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.collection)),stack1 == null || stack1 === false ? stack1 : stack1.length), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n<div class=\"paginatedLoadingIndicator\">Loading</div>\n\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  